import { useMutation, useQuery } from '@tanstack/react-query';
import { getEvaluationList, sendEvaluation } from '../api/evaluation';

export const useGetEvaluation = ({ enabled = true, ...params }) => {
  return useQuery({
    queryKey: ['evaluationList', enabled, params],
    queryFn: ({ signal }) => getEvaluationList(params, signal),
    enabled,
  });
};

export const useSendEvaluation = () => {
  return useMutation({
    mutationFn: ({ dto, signal }) => sendEvaluation(dto, signal),
  });
};
